import { formatSymbol } from "@/utils/i18n/format-symbol";

export const chartConfig = {
  zh: {
    overview: {
      revenueBreakdown: (symbol: string) => `${formatSymbol(symbol)} 營收分佈`,
      netIncome: (symbol: string) => `${formatSymbol(symbol)} 淨利`,
      cashFlow: (symbol: string) => `${formatSymbol(symbol)} 現金流`,
      profitMargin: (symbol: string) => `${formatSymbol(symbol)} 三率圖`,
      peStream: (symbol: string) => `${formatSymbol(symbol)} 本益比河流圖`,
    },
    financialReport: {
      financial: {
        revenueBreakdown: (symbol: string) =>
          `${formatSymbol(symbol)} 營收分佈`,
        eps: (symbol: string) => `${formatSymbol(symbol)} 每股盈餘`,
        epsDiluted: (symbol: string) => `${formatSymbol(symbol)} 稀釋每股盈餘`,
        revenue: (symbol: string) => `${formatSymbol(symbol)} 營收`,
        operationIncome: (symbol: string) => `${formatSymbol(symbol)} 營業利益`,
        netIncome: (symbol: string) => `${formatSymbol(symbol)} 淨利`,
        operatingExpenses: (symbol: string) =>
          `${formatSymbol(symbol)} 營業費用`,
        cashFlow: (symbol: string) => `${formatSymbol(symbol)} 現金流`,
        cashAndDebt: (symbol: string) => `${formatSymbol(symbol)} 現金 & 債務`,
      },
      valuation: {
        peRatio: (symbol: string) => `${formatSymbol(symbol)} 本益比`,
        psRatio: (symbol: string) => `${formatSymbol(symbol)} 股價營收比`,
        pbRatio: (symbol: string) => `${formatSymbol(symbol)} 股價淨值比`,
        forwardPe: (symbol: string) => `${formatSymbol(symbol)} 預期本益比`,
        evToEbitda: (symbol: string) => `${formatSymbol(symbol)} EV/EBITDA`,
        evToSales: (symbol: string) => `${formatSymbol(symbol)} EV/Sales`,
        peStream: (symbol: string) => `${formatSymbol(symbol)} 本益比河流圖`,
      },
      growth: {
        pegRatio: (symbol: string) => `${formatSymbol(symbol)} 本益成長比`,
        epsSurprise: (symbol: string) => `${formatSymbol(symbol)} 驚喜比率`,
        revenueSurprise: (symbol: string) =>
          `${formatSymbol(symbol)} 營收驚喜比率`,
      },
      profitability: {
        operatingRoa: (symbol: string) => `${formatSymbol(symbol)} 經營報酬率`,
        ros: (symbol: string) => `${formatSymbol(symbol)} 銷售利潤率`,
        profitMargin: (symbol: string) =>
          `${formatSymbol(symbol)} 利潤率（三率圖）`,
      },
    },
  },
  en: {
    overview: {
      revenueBreakdown: (symbol: string) =>
        `${formatSymbol(symbol)} Revenue by Segments`,
      netIncome: (symbol: string) => `${formatSymbol(symbol)} Net Income`,
      cashFlow: (symbol: string) => `${formatSymbol(symbol)} Cash Flow`,
      profitMargin: (symbol: string) => `${formatSymbol(symbol)} Profit Margin`,
      peStream: (symbol: string) => `${formatSymbol(symbol)} PE Ratio River`,
    },
    financialReport: {
      financial: {
        revenueBreakdown: (symbol: string) =>
          `${formatSymbol(symbol)} Revenue by Segments`,
        eps: (symbol: string) => `${formatSymbol(symbol)} EPS`,
        epsDiluted: (symbol: string) => `${formatSymbol(symbol)} EPS Diluted`,
        revenue: (symbol: string) => `${formatSymbol(symbol)} Revenue`,
        operationIncome: (symbol: string) =>
          `${formatSymbol(symbol)} Operation Income`,
        netIncome: (symbol: string) => `${formatSymbol(symbol)} Net Income`,
        operatingExpenses: (symbol: string) =>
          `${formatSymbol(symbol)} Operating Expenses`,
        cashFlow: (symbol: string) => `${formatSymbol(symbol)} Cash Flow`,
        cashAndDebt: (symbol: string) => `${formatSymbol(symbol)} Cash & Debt`,
      },
      valuation: {
        peRatio: (symbol: string) => `${formatSymbol(symbol)} P/E Ratio`,
        psRatio: (symbol: string) => `${formatSymbol(symbol)} P/S Ratio`,
        pbRatio: (symbol: string) => `${formatSymbol(symbol)} P/B Ratio`,
        forwardPe: (symbol: string) => `${formatSymbol(symbol)} Forward P/E`,
        evToEbitda: (symbol: string) => `${formatSymbol(symbol)} EV/EBITDA`,
        evToSales: (symbol: string) => `${formatSymbol(symbol)} EV/Sales`,
        peStream: (symbol: string) => `${formatSymbol(symbol)} PE Ratio River`,
      },
      growth: {
        pegRatio: (symbol: string) =>
          `${formatSymbol(symbol)} PEG Ratio (5yr expected)`,
        epsSurprise: (symbol: string) =>
          `${formatSymbol(symbol)} EPS Surprise %`,
        revenueSurprise: (symbol: string) =>
          `${formatSymbol(symbol)} Revenue Surprise %`,
      },
      profitability: {
        operatingRoa: (symbol: string) =>
          `${formatSymbol(symbol)} Operating ROA`,
        ros: (symbol: string) => `${formatSymbol(symbol)} ROS`,
        profitMargin: (symbol: string) =>
          `${formatSymbol(symbol)} Profit Margin`,
      },
    },
  },
};
